import styled from 'styled-components';
import { ButtonNoStyles } from '@styled';
import fonts from '@general/fonts';

const blue = '#2684ff';

export const ContainerOuterStyled = styled.div`
    box-sizing: border-box;
    position: relative;
`;

export const ControlContainerStyled = styled.div`
    align-items: center;
    background-color: white;
    border-color: #e4eaef;
    border-radius: 0;
    border-style: solid;
    border-width: 2px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    height: 56px;
    justify-content: space-between;
    min-height: 38px;
    outline: 0 !important;
    padding-left: 0.7rem;
    position: relative;
    transition: all 100ms;

    &:hover {
        border-color: hsl(0, 0%, 70%);
    }

    &.open {
        box-shadow: 0 0 0 1px ${blue};

        &:hover {
            border-color: ${blue};
        }
    }
`;

export const ValuesContainerStyled = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex: 1;
    flex-wrap: nowrap;
    font-family: ${fonts.sans};
    overflow: hidden;
    padding: 0;
    position: relative;
`;

export const PlaceholderContainerStyled = styled.div`
    box-sizing: border-box;
    color: #464a4c;
    font-family: ${fonts.sans};
    margin-left: 2px;
    margin-right: 2px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`;

export const CurrentSelectionContainerStyled = styled.div`
    background-color: hsl(0, 0%, 90%);
    border-radius: 2px;
    box-sizing: border-box;
    display: flex;
    margin: 2px;
    min-width: 0;
`;

export const CurrentSelectionLabelStyled = styled.div`
    border-radius: 2px;
    box-sizing: border-box;
    color: hsl(0, 0%, 20%);
    font-size: 85%;
    overflow: hidden;
    padding: 3px;
    padding-left: 6px;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const CurrentSelectionButtonStyled = styled(ButtonNoStyles)`
    align-items: center;
    border-radius: 2px;
    box-sizing: border-box;
    display: flex;
    padding-left: 4px;
    padding-right: 4px;

    &:hover {
        background-color: #ffbdad;
        color: #de350b;
    }
`;

export const InputContainerStyled = styled.div`
    box-sizing: 'border-box',
    color: hsl(0, 0%, 20%);
    font-family: ${fonts.sans};
    margin: 2px;
    padding-bottom: 2px;
    padding-top: 2px;
    visibility: visible;
`;

export const InputStyled = styled.input`
    box-sizing: content-box;
    background: 0px center;
    border: 0px;
    color: inherit;
    font-size: inherit;
    opacity: 1;
    outline: 0px;
    padding: 0px;
`;

export const IndicatorContainerStyled = styled.div`
    align-items: center;
    align-self: stretch;
    box-sizing: border-box;
    display: flex;
    flex-shrink: 0;
`;

export const IndicatorDividerStyled = styled.span`
    align-self: stretch;
    background-color: hsl(0, 0%, 80%);
    box-sizing: border-box;
    margin-bottom: 8px;
    margin-top: 8px;
    width: 1px;
`;

export const IndicatorIconContainerStyled = styled.div`
    color: hsl(0, 0%, 80%);
    box-sizing: border-box;
    display: flex;
    padding: 8px;
    transition: color 150ms;

    &:hover {
        color: hsl(0, 0%, 60%);
    }

    svg {
        fill: currentColor;
    }
`;

export const MenuContainerStyled = styled.div`
    top: 100%;
    background-color: hsl(0, 0%, 100%);
    border-radius: 4px;
    box-shadow: 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%);
    margin-bottom: 8px;
    margin-top: 8px;
    position: absolute;
    width: 100%;
    z-index: 1;
    box-sizing: border-box;
`;

export const MenuInnerStyled = styled.div`
    max-height: 300px;
    overflow-y: auto;
    padding-bottom: 4px;
    padding-top: 4px;
    position: relative;
    box-sizing: border-box;
    font-family: ${fonts.sans};
`;
